import {createContext, ReactElement, useEffect, useState} from "react";

import {getNavigation} from "@/api/navigation";
import {navParent} from "@/types/navigation";

export const GlobalContext = createContext<{navigation: navParent[] | null}>({
  navigation: null,
});

export function GlobalContextProvider({
  children,
}: {
  children: ReactElement;
}): ReactElement {
  const [navigation, setNavigation] = useState<null | navParent[]>(null);
  useEffect(() => {
    const callApiNavigation = async (): Promise<void> => {
      const nav = await getNavigation();
      setNavigation(nav);
    };
    callApiNavigation();
  }, []);

  return (
    <GlobalContext.Provider value={{navigation}}>
      {children}
    </GlobalContext.Provider>
  );
}
